<file-uploader
[label]="'common.file'|translate"
[placeholder]="input_placeholder"
[control]="input_formControlName"
[isDisabled]="input_isDisabled"
[loading]="loading"
class="tw-w-[275px]"
(onClearFile)="checkIsNullFile($event)"
(valueChange)="checkFile($event)"
acceptFile=".txt,.xls,.xlsx,.csv"
[maxFileSize]="1000"
sizeType="mb"
(onErrorFile)="showErrorDialog($event)">
</file-uploader>

<div class="tw-mt-[5px] tw-mb-[10px] alert alert-white border tw-flex tw-justify-between tw-items-center">
  <span> {{"common.mobileNumbersCount"|translate}} : </span>
  <span class="tw-font-semibold tw-text-[15px] text-dark" *ngIf="!pastedLoading">
    {{mobileNumbersCountInUploadFileMode}}
  </span>
  <span *ngIf="pastedLoading">
    <span class="spinner-border text-primary spinner-border-sm" role="status" aria-hidden="true"></span>
    <span class="sr-only">Loading...</span>
  </span>
</div>
